import React from "react";

import { Container } from "./styles";

interface IBilletSVG {
  className?: string;
}

const BilletSVG: React.FC<IBilletSVG> = ({ className }: IBilletSVG) => {
  return (
    <Container className={className}>
      <svg
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8009_10250)">
          <rect
            x="5"
            y="5"
            width="2"
            height="14"
            rx="1"
            fill="var(--text-color)"
          />
          <rect
            x="9"
            y="5"
            width="2"
            height="14"
            rx="1"
            fill="var(--text-color)"
          />
          <rect
            x="13"
            y="5"
            width="2"
            height="14"
            rx="1"
            fill="var(--text-color)"
          />
          <rect
            x="17"
            y="5"
            width="2"
            height="14"
            rx="1"
            fill="var(--text-color)"
          />
          <path
            d="M1 17V21.5C1 22.3284 1.67157 23 2.5 23H7"
            stroke="var(--text-color)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M1 7V2.5C1 1.67157 1.67157 1 2.5 1H7"
            stroke="var(--text-color)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M23 17V21.5C23 22.3284 22.3284 23 21.5 23H17"
            stroke="var(--text-color)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M23 7V2.5C23 1.67157 22.3284 1 21.5 1H17"
            stroke="var(--text-color)"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_8009_10250">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Container>
  );
};

export default BilletSVG;
